import React from "react";
import { EXPANSION, PATCH, SEASON } from "../../../lib/wowHelpers";
import SubtitleAndDescription from "../../Common/SubtitleAndDescription";
import { getEnchantName, trimQuality, getEnchantImgLinkSrc } from "lib/enchant-ids";

const EnchantBox = ({ enchant, title }) => {
  return (
    <div className="enchant-box">
      <div className="enchant-img">
        <img src={getEnchantImgLinkSrc(enchant)} alt={title} />
      </div>
      <div className="title-and-enchant">
        <div className="enchant-title">
          {title} <span className="enchant-text">Enchant</span>
        </div>
        <div className="enchant">{trimQuality(getEnchantName(enchant)) ?? ""}</div>
      </div>
    </div>
  );
};

const BestEnchants = ({ displayClassName, displaySpecName, enchants }) => {
  const equipmentSlots = [
    { key: "perm_weapon1", title: "Main Hand" },
    { key: "perm_weapon2", title: "Off Hand" },
    { key: "perm_cape", title: "Back" },
    { key: "perm_chest", title: "Chest" },
    { key: "perm_wrist", title: "Wrist" },
    { key: "perm_belt", title: "Waist" },
    { key: "perm_legs", title: "Legs" },
    { key: "perm_feet", title: "Feet" },
    { key: "perm_ring1", title: "Ring" },
  ];

  const getTopEnchant = (enchantments) => {
    const sortedEnchants = Object.entries(enchantments ?? {}).sort((a, b) => parseFloat(b[1].perc) - parseFloat(a[1].perc));

    // If the most popular enchant is no enchant, then get the next most popular
    const topEnchant = sortedEnchants[0]?.[0] ? sortedEnchants[0] : sortedEnchants[1];

    return topEnchant?.[0];
  };

  return (
    <div className="best-enchants-container">
      <SubtitleAndDescription
        subtitle={`Best ${displaySpecName} ${displayClassName} Enchants in ${EXPANSION} Season ${SEASON} - Patch ${PATCH}`}
        marginLeft="0"
      />
      <div className="enchant-boxes">
        {equipmentSlots.map(({ key, title }, index) => {
          const topEnchant = getTopEnchant(enchants?.[key]);

          return enchants ? (
            topEnchant ? (
              <EnchantBox enchant={topEnchant} key={index} title={title} />
            ) : null
          ) : (
            <EnchantBox enchant="" key={index} title={title} />
          );
        })}
      </div>
    </div>
  );
};

export default BestEnchants;
